// (function () {
//   'use strict';

//   // ─── CONFIG ────────────────────────────────────────────────────────────────
//   const CONFIG = {
//     termsUrl: '/policies/terms-of-service',
//     privacyUrl: '/policies/privacy-policy',
//     checkboxLabel: 'By submitting a message, you agree to our',
//     termsText: 'Terms of Service',
//     privacyText: 'Privacy Policy',
//     targets: [
//       {
//         id: 'terms-product-page',
//         insertBefore: '[data-shopify="payment-button"]',
//         disableTarget: '[data-shopify="payment-button"]',
//         runOnPages: ['/products/'],
//         checkedByDefault: false,
//       },
//       {
//         id: 'terms-cart-notification',
//         insertBefore: '#cart-notification-form',
//         disableTarget: '#cart-notification-form button[name="checkout"]',
//         runOnPages: [],
//         checkedByDefault: false,
//       },
//       {
//         id: 'terms-cart-page',
//         insertBefore: '.cart__ctas',
//         disableTarget: '#checkout, .cart__dynamic-checkout-buttons',
//         runOnPages: ['/cart'],
//         checkedByDefault: false,
//       },
//     ],
//   };

//   const STYLES = `
//     .terms-checkbox-wrapper { display: flex; align-items: flex-start; gap: 8px; margin: 10px 0 8px 0; font-size: 13px; line-height: 1.5; }
//     .terms-checkbox-wrapper input { margin-top: 3px; width: 15px; height: 15px; cursor: pointer; accent-color: #000; }
//     .terms-checkbox-wrapper a { text-decoration: underline; color: inherit; }
//     .terms-btn--disabled { opacity: 0.4 !important; pointer-events: none !important; }
//     .terms-btn--disabled * { pointer-events: none !important; }
//     .clickwrap-container { font-size: 12px; margin-bottom: 6px; }
//     .clickwrap-container a { color: #007bff; }
//   `;

//   let stylesInjected = false;
//   function injectStyles() {
//     if (stylesInjected) return;
//     const style = document.createElement('style');
//     style.textContent = STYLES;
//     document.head.appendChild(style);
//     stylesInjected = true;
//   }

//   function isAllowedPage(patterns) {
//     if (!patterns || patterns.length === 0) return true;
//     return patterns.some((p) => window.location.pathname.includes(p));
//   }

//   function buildCheckboxWrapper(id, checked) {
//     const wrapper = document.createElement('div');
//     wrapper.className = 'terms-checkbox-wrapper';
//     wrapper.dataset.termsFor = id;
//     wrapper.innerHTML = `
//       <input type="checkbox" id="${id}" ${checked ? 'checked' : ''}>
//       <label for="${id}">
//         ${CONFIG.checkboxLabel}
//         <a style="color:blue;" href="${CONFIG.termsUrl}" target="_blank">${CONFIG.termsText}</a>
//         and
//         <a style="color:blue;" href="${CONFIG.privacyUrl}" target="_blank">${CONFIG.privacyText}</a>.
//       </label>
//     `;
//     return wrapper;
//   }

//   function blockClick(e) { e.preventDefault(); e.stopPropagation(); }

//   function setDisabled(selector, disabled) {
//     const elements = document.querySelectorAll(selector);
//     if (!elements.length) return;
//     elements.forEach((el) => {
//       if (disabled) {
//         el.classList.add('terms-btn--disabled');
//         el.setAttribute('aria-disabled', 'true');
//         el.addEventListener('click', blockClick, true);
//       } else {
//         el.classList.remove('terms-btn--disabled');
//         el.removeAttribute('aria-disabled');
//         el.removeEventListener('click', blockClick, true);
//       }
//     });
//   }

//   function setupTarget(target) {
//     if (!isAllowedPage(target.runOnPages)) return false;
//     const insertEl = document.querySelector(target.insertBefore);
//     if (!insertEl) return false;
//     if (document.querySelector(`[data-terms-for="${target.id}"]`)) return true;

//     injectStyles();
//     const checkboxWrapper = buildCheckboxWrapper(target.id, target.checkedByDefault);
//     const checkbox = checkboxWrapper.querySelector('input');
//     insertEl.parentNode.insertBefore(checkboxWrapper, insertEl);

//     setDisabled(target.disableTarget, !target.checkedByDefault);

//     checkbox.addEventListener('change', function () {
//       setDisabled(target.disableTarget, !this.checked);
//     });

//     return true;
//   }

//   function waitAndSetup(target, timeout = 8000) {
//     if (document.querySelector(target.insertBefore)) {
//       setupTarget(target);
//       return;
//     }
//     const observer = new MutationObserver(() => {
//       if (document.querySelector(target.insertBefore)) {
//         observer.disconnect();
//         setTimeout(() => setupTarget(target), 80);
//       }
//     });
//     observer.observe(document.body, { childList: true, subtree: true });
//     setTimeout(() => observer.disconnect(), timeout);
//   }

//   function watchCartNotification() {
//     const cartTargets = CONFIG.targets.filter(
//       t => t.insertBefore.includes('cart-notification') || t.disableTarget.includes('cart-notification')
//     );
//     if (!cartTargets.length) return;

//     const cartNotification = document.querySelector('cart-notification');
//     if (!cartNotification) return;

//     const observer = new MutationObserver((mutations) => {
//       for (const mutation of mutations) {
//         const hasRealContent = [...mutation.addedNodes].some(
//           node => node.nodeType === 1 && !node.classList?.contains('terms-checkbox-wrapper')
//         );
//         if (!hasRealContent) continue;

//         cartTargets.forEach(target => {
//           const exists = document.querySelector(`[data-terms-for="${target.id}"]`);
//           if (!exists) setTimeout(() => setupTarget(target), 100);
//         });
//         break;
//       }
//     });

//     observer.observe(cartNotification, { childList: true, subtree: true });
//   }

//   // ─── SHOPIFY CHAT CLICKWRAP ────────────────────────────────────────────────
//   function addChatClickWrap() {
//     const chat = document.querySelector('#ShopifyChat');
//     if (!chat || !chat.shadowRoot) return;

//     const shadow = chat.shadowRoot;

//     // Inject CSS inside Shopify Chat shadow DOM
// if (!shadow.querySelector('#clickwrap-styles')) {
//   const style = document.createElement('style');
//   style.id = 'clickwrap-styles';
//   style.textContent = `
//     .clickwrap-container {
//       font-size: 12px;
//       margin-bottom: 8px;
//       padding: 8px 10px;
//       border-radius: 8px;
//       background: #f4f6f8;
//       border: 1px solid #e1e3e5;
//     }

//     .clickwrap-container label {
//       display: flex;
//       gap: 8px;
//       align-items: flex-start;
//       cursor: pointer;
//       line-height: 1.4;
//       color: #2d3748;
//     }

//     .clickwrap-container input[type="checkbox"] {
//       margin-top: 2px;
//       width: 15px;
//       height: 15px;
//       accent-color: #000;
//       cursor: pointer;
//       flex-shrink: 0;
//     }

//     .clickwrap-container a {
//       color: blue;
//       text-decoration: none;
//       font-weight: 500;
//     }

//     .clickwrap-container a:hover {
//       text-decoration: underline;
//     }
//   `;
//   shadow.appendChild(style);
// }

//     const form = shadow.querySelector('.composer-bar-form');
//     const sendBtn = shadow.querySelector('[data-spec="message-submit"]');
//     const messageInput = shadow.querySelector('textarea, input[type="text"]');

//     if (!form || form.querySelector('.clickwrap-container')) return;

//     const div = document.createElement('div');
//     div.className = 'clickwrap-container';
//     div.style.fontSize = '12px';
//     div.style.marginBottom = '6px';

//     div.innerHTML = `
//   <label>
//     <input type="checkbox" id="chat-clickwrap">
//     <span>
//       By submitting a message, you agree to our
//       <a href="/policies/terms-of-service" target="_blank">Terms of Service</a>
//       and
//       <a href="/policies/privacy-policy" target="_blank">Privacy Policy</a>.
//     </span>
//   </label>
// `;

//     form.prepend(div);

//     // Disable message input initially
//     messageInput.disabled = true;
//     sendBtn.disabled = true;

//     const checkbox = div.querySelector('#chat-clickwrap');

//     // Checkbox controls message input
//     checkbox.addEventListener('change', function () {
//       messageInput.disabled = !this.checked;
//       if (!this.checked) sendBtn.disabled = true;
//     });

//     // Enable send button only if there is text in input
//     messageInput.addEventListener('input', function () {
//       sendBtn.disabled = !this.value.trim();
//     });
//   }

//   function waitForChat() {
//   const interval = setInterval(() => {
//     const chat = document.querySelector('#ShopifyChat');

//     if (chat && chat.shadowRoot) {
//       clearInterval(interval);

//       const shadow = chat.shadowRoot;

//       // ✅ Run once initially
//       addChatClickWrap();

//       // ✅ Observe internal changes (THIS is the real fix)
//       const observer = new MutationObserver(() => {
//         const form = shadow.querySelector('.composer-bar-form');

//         if (form && !shadow.querySelector('.clickwrap-container')) {
//           addChatClickWrap();
//         }
//       });

//       observer.observe(shadow, {
//         childList: true,
//         subtree: true,
//       });
//     }
//   }, 500);
// }


//   // ─── INIT ──────────────────────────────────────────────────────────────────
//   document.addEventListener('DOMContentLoaded', function () {
//     CONFIG.targets.forEach(waitAndSetup);
//     watchCartNotification();
//     waitForChat();
//   });

// })();











(function () { 
  'use strict';

  // ─── CONFIG ────────────────────────────────────────────────────────────────
  const CONFIG = {
    termsUrl: '/policies/terms-of-service',
    privacyUrl: '/policies/privacy-policy',
    checkboxLabel: 'By submitting a message, you agree to our',
    termsText: 'Terms of Service',
    privacyText: 'Privacy Policy',
    targets: [
      {
        id: 'terms-product-page',
        insertBefore: '[data-shopify="payment-button"]',
        disableTarget: '[data-shopify="payment-button"]',
        runOnPages: ['/products/'],
        checkedByDefault: false,
        label: 'By clicking "Check Out" you agree to our',
      },
      {
        id: 'terms-cart-notification',
        insertBefore: '#cart-notification-form',
        disableTarget: '#cart-notification-form button[name="checkout"]',
        runOnPages: [],
        checkedByDefault: false,
        label: 'By clicking "Check Out" you agree to our',
      },
      {
        id: 'terms-cart-page',
        insertBefore: '.cart__ctas',
        disableTarget: '#checkout, .cart__dynamic-checkout-buttons',
        runOnPages: ['/cart'],
        checkedByDefault: false,
        label: 'By clicking "Check Out" you agree to our',
      },
    ],
  };

  const STYLES = `
    .terms-checkbox-wrapper { display: flex; align-items: flex-start; gap: 8px; margin: 10px 0 8px 0; font-size: 13px; line-height: 1.5; }
    .terms-checkbox-wrapper input { margin-top: 3px; width: 15px; height: 15px; cursor: pointer; accent-color: #000; }
    .terms-checkbox-wrapper a { text-decoration: underline; color: inherit; }
    .terms-btn--disabled { opacity: 0.4 !important; pointer-events: none !important; }
    .terms-btn--disabled * { pointer-events: none !important; }
    .clickwrap-container { font-size: 12px; margin-bottom: 6px; }
    .clickwrap-container a { color: #007bff; }
  `;

  let stylesInjected = false;
  function injectStyles() {
    if (stylesInjected) return;
    const style = document.createElement('style');
    style.textContent = STYLES;
    document.head.appendChild(style);
    stylesInjected = true;
  }

  function isAllowedPage(patterns) {
    if (!patterns || patterns.length === 0) return true;
    return patterns.some((p) => window.location.pathname.includes(p));
  }

  // ✅ UPDATED FUNCTION
  function buildCheckboxWrapper(target, checked) {
    const wrapper = document.createElement('div');
    wrapper.className = 'terms-checkbox-wrapper';
    wrapper.dataset.termsFor = target.id;

    wrapper.innerHTML = `
      <input type="checkbox" id="${target.id}" ${checked ? 'checked' : ''}>
      <label for="${target.id}">
        ${target.label || CONFIG.checkboxLabel}
        <a style="color:blue;" href="${CONFIG.termsUrl}" target="_blank">${CONFIG.termsText}</a>
        and
        <a style="color:blue;" href="${CONFIG.privacyUrl}" target="_blank">${CONFIG.privacyText}</a>.
      </label>
    `;
    return wrapper;
  }

  function blockClick(e) { e.preventDefault(); e.stopPropagation(); }

  function setDisabled(selector, disabled) {
    const elements = document.querySelectorAll(selector);
    if (!elements.length) return;
    elements.forEach((el) => {
      if (disabled) {
        el.classList.add('terms-btn--disabled');
        el.setAttribute('aria-disabled', 'true');
        el.addEventListener('click', blockClick, true);
      } else {
        el.classList.remove('terms-btn--disabled');
        el.removeAttribute('aria-disabled');
        el.removeEventListener('click', blockClick, true);
      }
    });
  }

  function setupTarget(target) {
    if (!isAllowedPage(target.runOnPages)) return false;
    const insertEl = document.querySelector(target.insertBefore);
    if (!insertEl) return false;
    if (document.querySelector(`[data-terms-for="${target.id}"]`)) return true;

    injectStyles();

    // ✅ UPDATED CALL
    const checkboxWrapper = buildCheckboxWrapper(target, target.checkedByDefault);

    const checkbox = checkboxWrapper.querySelector('input');
    insertEl.parentNode.insertBefore(checkboxWrapper, insertEl);

    setDisabled(target.disableTarget, !target.checkedByDefault);

    checkbox.addEventListener('change', function () {
      setDisabled(target.disableTarget, !this.checked);
    });

    return true;
  }

  function waitAndSetup(target, timeout = 8000) {
    if (document.querySelector(target.insertBefore)) {
      setupTarget(target);
      return;
    }
    const observer = new MutationObserver(() => {
      if (document.querySelector(target.insertBefore)) {
        observer.disconnect();
        setTimeout(() => setupTarget(target), 80);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), timeout);
  }

  function watchCartNotification() {
    const cartTargets = CONFIG.targets.filter(
      t => t.insertBefore.includes('cart-notification') || t.disableTarget.includes('cart-notification')
    );
    if (!cartTargets.length) return;

    const cartNotification = document.querySelector('cart-notification');
    if (!cartNotification) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const hasRealContent = [...mutation.addedNodes].some(
          node => node.nodeType === 1 && !node.classList?.contains('terms-checkbox-wrapper')
        );
        if (!hasRealContent) continue;

        cartTargets.forEach(target => {
          const exists = document.querySelector(`[data-terms-for="${target.id}"]`);
          if (!exists) setTimeout(() => setupTarget(target), 100);
        });
        break;
      }
    });

    observer.observe(cartNotification, { childList: true, subtree: true });
  }

  // ─── SHOPIFY CHAT CLICKWRAP (UNCHANGED) ─────────────────────────────────────
  function addChatClickWrap() {
    const chat = document.querySelector('#ShopifyChat');
    if (!chat || !chat.shadowRoot) return;

    const shadow = chat.shadowRoot;

    if (!shadow.querySelector('#clickwrap-styles')) {
      const style = document.createElement('style');
      style.id = 'clickwrap-styles';
      style.textContent = `
        .clickwrap-container {
          font-size: 12px;
          margin-bottom: 8px;
          padding: 8px 10px;
          border-radius: 8px;
          background: #f4f6f8;
          border: 1px solid #e1e3e5;
        }
        .clickwrap-container label {
          display: flex;
          gap: 8px;
          align-items: flex-start;
          cursor: pointer;
          line-height: 1.4;
          color: #2d3748;
        }
        .clickwrap-container input[type="checkbox"] {
          margin-top: 2px;
          width: 15px;
          height: 15px;
          accent-color: #000;
          cursor: pointer;
          flex-shrink: 0;
        }
        .clickwrap-container a {
          color: blue;
          text-decoration: none;
          font-weight: 500;
        }
        .clickwrap-container a:hover {
          text-decoration: underline;
        }
      `;
      shadow.appendChild(style);
    }

    const form = shadow.querySelector('.composer-bar-form');
    const sendBtn = shadow.querySelector('[data-spec="message-submit"]');
    const messageInput = shadow.querySelector('textarea, input[type="text"]');

    if (!form || form.querySelector('.clickwrap-container')) return;

    const div = document.createElement('div');
    div.className = 'clickwrap-container';

    div.innerHTML = `
      <label>
        <input type="checkbox" id="chat-clickwrap">
        <span>
          By submitting a message, you agree to our
          <a href="/policies/terms-of-service" target="_blank">Terms of Service</a>
          and
          <a href="/policies/privacy-policy" target="_blank">Privacy Policy</a>.
        </span>
      </label>
    `;

    form.prepend(div);

    messageInput.disabled = true;
    sendBtn.disabled = true;

    const checkbox = div.querySelector('#chat-clickwrap');

    checkbox.addEventListener('change', function () {
      messageInput.disabled = !this.checked;
      if (!this.checked) sendBtn.disabled = true;
    });

    messageInput.addEventListener('input', function () {
      sendBtn.disabled = !this.value.trim();
    });
  }

  function waitForChat() {
    const interval = setInterval(() => {
      const chat = document.querySelector('#ShopifyChat');

      if (chat && chat.shadowRoot) {
        clearInterval(interval);

        const shadow = chat.shadowRoot;

        addChatClickWrap();

        const observer = new MutationObserver(() => {
          const form = shadow.querySelector('.composer-bar-form');

          if (form && !shadow.querySelector('.clickwrap-container')) {
            addChatClickWrap();
          }
        });

        observer.observe(shadow, {
          childList: true,
          subtree: true,
        });
      }
    }, 500);
  }

  // ─── INIT ──────────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    CONFIG.targets.forEach(waitAndSetup);
    watchCartNotification();
    waitForChat();
  });

})();